import React from "react";
import { Container } from "react-bootstrap";
import "./Technology.css";
import d3 from "../../../Asset/technology/D3.svg";
import gwt from "../../../Asset/technology/GWT.svg";
import jquery from "../../../Asset/technology/Jquery.svg";
import react from "../../../Asset/technology/React.svg";
import angular from "../../../Asset/technology/Angular.svg";
import backbone from "../../../Asset/technology/Backbone.svg";
import hiber from "../../../Asset/technology/Hibernate.svg";
import java from "../../../Asset/technology/Java.svg";
import node from "../../../Asset/technology/Node-js-Express.svg";
import spring from "../../../Asset/technology/Spring.svg";
import php from "../../../Asset/technology/Php.svg";
import wordpress from "../../../Asset/technology/Wordpress.svg";
import laravel from "../../../Asset/technology/Laravel.svg";
import codeig from "../../../Asset/technology/Codeigniter1.svg";
import mysql from "../../../Asset/technology/mysql.svg";
import neo4j from "../../../Asset/technology/neo4j.svg";
import postgress from "../../../Asset/technology/postgress-sql.svg";
import redis from "../../../Asset/technology/redis.svg";
import influx from "../../../Asset/technology/influx.svg";
import mongo from "../../../Asset/technology/mongoDB.svg";
import ionic from "../../../Asset/technology/Ionic.svg";
import reactNative from "../../../Asset/technology/React-native.svg";
import aws from "../../../Asset/technology/AWS.svg";
import gcloud from "../../../Asset/technology/Google-Cloud.png";
import shopify from "../../../Asset/d2c/Shopify.svg";

const Technology = () => {
  const techItems = [
    { name: "Chatgpt" },
    { name: "Meta" },
    { name: "Mistral AI" },
    { name: "Grok" },
    { name: "Tensorflow" },
    { name: "Anthropic" },
    { name: "Hugging Face" },
    { name: "Llamaindex" },
    { name: "Langchain" },
    { name: "Pinecone" },
    { name: "Gemini" },
    { name: "D3", icon: d3 },
    { name: "GWT", icon: gwt },
    { name: "Jquery", icon: jquery },
    { name: "React", icon: react },
    { name: "Angular", icon: angular },
    { name: "Backbone", icon: backbone },
    { name: "Hibernate", icon: hiber },
    { name: "Java/J2EE", icon: java },
    { name: "Node/Express", icon: node },
    { name: "Spring", icon: spring },
    { name: "Php", icon: php },
    { name: "Wordpress", icon: wordpress },
    { name: "Shopify", icon: shopify },
    { name: "Wix" },
    { name: "Codeigniter", icon: codeig },
    { name: "Mysql", icon: mysql },
    { name: "Neo4j", icon: neo4j },
    { name: "Postgress sql", icon: postgress },
    { name: "Redis", icon: redis },
    { name: "Influx", icon: influx },
    { name: "mongoDB", icon: mongo },
    { name: "Ionic", icon: ionic },
    { name: "React native", icon: reactNative },
    { name: "AWS", icon: aws },
    { name: "Google cloud", icon: gcloud },
    { name: "Azure Cloud" },
  ];

  const getInitials = (label) =>
    label
      .split(" ")
      .map((part) => part[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();

  return (
    <>
      <section className="technology-stack-section">
        <Container>
          <div className="technology-stack-header">
            <h2 className="technology-stack-title">Technology Stack</h2>
            <div className="technology-stack-counter">
              <span className="stack-count">
                <span className="stack-count-main">50</span>
                <span className="stack-count-plus">+</span>
              </span>
              <span className="stack-label">Technologies</span>
            </div>
          </div>
          <div className="technology-stack-chips">
            {techItems.map((item) => (
              <div className="tech-chip" key={item.name}>
                {item.icon ? (
                  <img src={item.icon} alt={`${item.name} logo`} />
                ) : (
                  <span className="tech-chip-initial">
                    {getInitials(item.name)}
                  </span>
                )}
                <span className="tech-chip-label">{item.name}</span>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Technology;
